import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { EncryptedInstructionDocumentTypeRequest } from '../../Models/Models/Documents/InstructionDocuments/EncryptedInstructionDocumentTypeRequest';
import { ContributionAndWithdrawalBase } from '../../Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionDocumentTypeContributionAndWithdrawalBaseRequestTriggerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(contributionAndWithdrawalBase: ContributionAndWithdrawalBase): Promise<Array<EncryptedInstructionDocumentTypeRequest>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/InstructionDocumentTypeContributionAndWithdrawalBaseRequestTrigger/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { contributionAndWithdrawalBase: contributionAndWithdrawalBase }

    return AjaxWrapper.post<Array<EncryptedInstructionDocumentTypeRequest>, any>(url, data);
  }
}

